import { each } from "jquery";

export default class ProductAdder extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if ($(".product-retail").length == 0) {
            $("#submit_retail").prop('disabled', true);
        } else {
            $("#submit_retail").prop('disabled', false);
        }
        this.events();
    }

    askToDelete( deleteText, buttonText, cancelButtonText, callback ) {
        swal({
            title: '',
            html: "<span style='color: #F17474;'>" + deleteText + "</span>",
            allowOutsideClick: true,
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: true,
            confirmButtonColor: '#ee0000',
            cancelButtonText: cancelButtonText,
            confirmButtonText: buttonText,
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function ( resolve ) {
                    if ( callback ) {
                        callback( resolve );
                    }
                });
            }
        }).then(function () {
            swal.close();
        });
    }

    events() {
        $("#add_product").on("click", (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            var $product_id = $(".form-select").val();
            var $product_name = $(".select2-selection__rendered").attr('title');
            var $listElement = $("#products");

            var $existing = $(`[for="${$product_name}"]`);

            if ($existing.length == 0) {
                var $html = `
                <div class="d-flex flex-row justify-content-center align-items-center product-retail my-2" id="product_${$product_id}">
                    <label for="${$product_name}" class="w-100">${$product_name}</label>
                    <input class="mx-2 form-control has-validation" required value="1" min="1" name="qte_${$product_id}" type="number" data-product_id="${$product_id}">
                    <button class="btn btn-group rm_product" data-id_to_remove=${$product_id}>
                        <i class="uil uil-minus"></i>
                    </button>
                </div>`
                
                $listElement.append($html);

                $(".rm_product").on("click", (e) => {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    var target = e.currentTarget;
                    $(`#product_${$(target).data("id_to_remove")}`).remove();

                    if ($(".product-retail").length == 0) {
                        $("#submit_retail").prop('disabled', true);
                    }
                });

                if ($(".product-retail").length == 0) {
                    $("#submit_retail").prop('disabled', true);
                } else {
                    $("#submit_retail").prop('disabled', false);
                }
            }
        });

        $(".rm_product").on("click", (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            var target = e.currentTarget;
            $(`#product_${$(target).data("id_to_remove")}`).remove();

            if ($(".product-retail").length == 0) {
                $("#submit_retail").prop('disabled', true);
            } else {
                $("#submit_retail").prop('disabled', false);
            }
        });

        $("#empty_retail").on("click", (e) => {
            e.stopImmediatePropagation();
            e.preventDefault();
            var target = e.currentTarget;
            var url = $(target).data('empty_url');
            this.askToDelete( "Voulez vous vraiment vider ce panier ?", "Vider", "Annuler", ( callback ) => {
                window.location.replace(url);
            });
        });
    }
}
